module.exports = __webpack_public_path__ + "static/media/backwards.1a5a080b.svg";